import { useTheme } from '@material-ui/core';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import { Theme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

export function useIsMobile(breakpoint?: Breakpoint): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(breakpoint ? breakpoint : 'sm'));
}

export const isMobileWebChannel = (theme: Theme): boolean => window.innerWidth <= theme.breakpoints.values.md;
